import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { apiClient } from '../../../apiClient'
import { OrderData, PoojaOrder, BillItem, Bill } from './types'

class OrdersApi {
  private api: AxiosInstance

  constructor(config: AxiosRequestConfig) {
    this.api = apiClient.create(config)
  }

  getOrders = (
    pageNo: string,
    orderStatus: string,
    serviceType: string,
    bookingId: string,
    contactNumber: string,
    userId: string,
    storeId: string | undefined,
    bookingWhatsapp: string,
    bookingMemberData: string,
  ) =>
    this.api.get<PoojaOrder>(`/gw1/puja/internal/v1/orders`, {
      params: {
        page_no: pageNo,
        order_status: orderStatus,
        ...(serviceType && { service_type: serviceType }),
        ...(bookingId && { booking_id: bookingId }),
        ...(contactNumber && { contact_number: contactNumber }),
        ...(userId && { user_id: userId }),
        ...(storeId && { store_id: storeId }),
        ...(bookingWhatsapp && { booking_whatsapp_number: bookingWhatsapp }),
        ...(bookingMemberData && { booking_member_data: bookingMemberData }),
      },
    })
  // .then(response => {
  //   // Mock bill property for each order until BE deployment
  //   if (response.data?.data?.orders) {
  //     response.data.data.orders = response.data.data.orders.map(order => ({
  //       ...order,
  //       bill: this.mockBillFromOrder(order)
  //     }))
  //   }
  //   return response
  // })

  // private mockBillFromOrder = (order: any): Bill => {
  //   const billItems: BillItem[] = []

  //   // Add items from order.items if available
  //   if (order.items && Array.isArray(order.items)) {
  //     order.items.forEach((item: any, index: number) => {
  //       billItems.push({
  //         inventory_id: item.inventory_id || item.id || index + 1,
  //         name: item.name || `Item ${index + 1}`,
  //         price: item.amount || item.price || 0
  //       })
  //     })
  //   }

  //   // Add items from order.add_ons if available
  //   if (order.add_ons && Array.isArray(order.add_ons)) {
  //     order.add_ons.forEach((addon: any, index: number) => {
  //       billItems.push({
  //         inventory_id: addon.inventory_id || addon.id || (1000 + index + 1), // Different range for add-ons
  //         name: addon.name || `Add-on ${index + 1}`,
  //         price: addon.amount || addon.price || 0
  //       })
  //     })
  //   }

  //   return {
  //     other_charges_refunded: false,
  //     items: billItems,
  //     total_amount: 120
  //   }
  // }

  getOrderByBookingId = (bookingId: string) =>
    this.api.get<OrderData>(
      `/gw2/puja/internal/v1/orders/booking-id/${bookingId}`,
      {},
    )

  updateOrder = (orderId: string, action: string, payload: any) =>
    this.api.patch(
      `/gw1/puja/internal/v1/orders/${orderId}/${action}`,
      payload,
      {
        headers: { 'x-afb-platform': 'web' },
      },
    )

  // Pooja refund API
  createRefund = (orderId: string, payload: any) =>
    this.api.post(
      `/gw2/puja/internal/v1/orders/${orderId}/refund`,
      payload,
      {
        headers: { 'x-afb-platform': 'web' },
      },
    )
}

export default OrdersApi
